// TelemetryTab.jsx - 遥测数据Tab组件
import React from 'react';
import { InputNumber, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  MeterTable,
  BmsTable,
  PcsTable,
  AircondTable,
  MpptTable,
  LiquidCoolTable,
  ChargerTable,
  ReportTable,
  CellTable,
  EmsTable,
  IoTable,
  MicroGridTable,
  SubEmsTable,
  CabTable,
} from './TelemetryTables';

const COLORS = { primary: '#00d4ff', muted: 'rgba(255,255,255,0.6)' };

const TelemetryTab = ({ telemetry, dashboardData, pollInterval, setPollInterval, lastUpdate, onRefresh }) => {
  const { t } = useTranslation();

  const hasData = telemetry.controller?.length > 0 || telemetry.ems?.length > 0 || telemetry.meter?.length > 0;

  return (
    <div style={{ padding: '16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ color: COLORS.muted, fontSize: 12 }}>
          <Space size={12} align="center">
            <span>{t('cloud.pollingInterval')}:</span>
            <InputNumber
              min={1} max={300}
              value={pollInterval / 1000}
              onChange={v => setPollInterval((v || 1) * 1000)}
              addonAfter={t('cloud.second')}
              style={{ width: 120 }}
              size="small"
            />
            {lastUpdate && <span>{t('cloud.lastUpdate')}{lastUpdate.toLocaleTimeString()}</span>}
          </Space>
        </div>
      </div>

      <EmsTable data={telemetry.ems} />
      <IoTable data={telemetry.io} />
      <MicroGridTable data={telemetry.micro_grid} />
      <SubEmsTable data={telemetry.sub_ems} />
      <CabTable data={telemetry.cab} />
      <MeterTable data={telemetry.meter} />
      <BmsTable data={telemetry.bms} />
      <PcsTable data={telemetry.pcs} />
      <AircondTable data={telemetry.aircond} />
      <MpptTable data={telemetry.mppt} />
      <LiquidCoolTable data={telemetry.liquid_cool} />
      <ChargerTable data={telemetry.charger} />
      <ReportTable data={telemetry.report} />
      <CellTable data={telemetry.cell} />

      {!hasData && !lastUpdate && (
        <div style={{ textAlign: 'center', padding: 40, color: COLORS.muted }}>
          <span>{t('cloud.loadingTelemetry')}</span>
        </div>
      )}
    </div>
  );
};

export default TelemetryTab;
